import {
  IconArrowsUpDown,
  IconBox,
  IconLayers,
  IconListSquare,
  IconSettings,
  IconShieldCheck,
  IconTextSearch,
  IconVariable,
} from "@teral/icons";
import { routes } from "./routes";
import type { ResolvedNavLink } from "./types";

export function buildWorkspaceSections(slug: string, segments: string[]): ResolvedNavLink[] {
  const top = segments[0];

  return [
    {
      key: "projects",
      label: "Projects",
      href: routes.projects.list({ workspaceSlug: slug }),
      icon: IconBox,
      isActive: top === "projects",
    },
    {
      key: "audit",
      label: "Audit Log",
      href: `/${slug}/audit`,
      icon: IconTextSearch,
      isActive: top === "audit",
    },
    {
      key: "settings",
      label: "Settings",
      href: routes.settings.general({ workspaceSlug: slug }),
      icon: IconSettings,
      isActive: top === "settings",
    },
  ];
}

export function buildProjectLinks(
  slug: string,
  projectId: string,
  segments: string[],
): ResolvedNavLink[] {
  const page = segments[2];
  const scope = { workspaceSlug: slug, projectId };
  return [
    {
      key: "apps",
      label: "Apps",
      href: routes.projects.detail(scope),
      icon: IconBox,
      isActive: !page,
    },
    {
      key: "logs",
      label: "Logs",
      href: routes.projects.logs(scope),
      icon: IconLayers,
      isActive: page === "logs",
    },
    {
      key: "requests",
      label: "Requests",
      href: routes.projects.requests(scope),
      icon: IconArrowsUpDown,
      isActive: page === "requests",
    },
    {
      key: "settings",
      label: "Project Settings",
      href: routes.projects.settings(scope),
      icon: IconSettings,
      isActive: page === "settings",
    },
  ];
}

export function buildAppLinks(
  slug: string,
  projectId: string,
  appId: string,
  segments: string[],
): ResolvedNavLink[] {
  const page = segments[4];
  const scope = { workspaceSlug: slug, projectId, appId };
  return [
    {
      key: "overview",
      label: "Overview",
      href: routes.projects.apps.overview(scope),
      icon: IconBox,
      isActive: page === "overview",
    },
    {
      key: "deployments",
      label: "Deployments",
      href: routes.projects.apps.deployments(scope),
      icon: IconListSquare,
      isActive: page === "deployments",
    },
    {
      key: "env-vars",
      label: "Environment Variables",
      href: routes.projects.apps.envVars(scope),
      icon: IconVariable,
      isActive: page === "env-vars",
    },
    {
      key: "policies",
      label: "Policies",
      href: routes.projects.apps.policies(scope),
      icon: IconShieldCheck,
      isActive: page === "policies",
    },
    {
      key: "settings",
      label: "App Settings",
      href: routes.projects.apps.settings(scope),
      icon: IconSettings,
      isActive: page === "settings",
    },
    {
      key: "logs",
      label: "Go to Logs",
      href: routes.projects.logs(scope),
      icon: IconLayers,
      isActive: page === "logs",
      separatorAbove: true,
    },
    {
      key: "requests",
      label: "Go to Requests",
      href: routes.projects.requests(scope),
      icon: IconArrowsUpDown,
      isActive: page === "requests",
    },
  ];
}
